import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { Row, Col } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  deleteItemsCheckList,
  getChecklistCategory,
  getChecklistCommentCount,
  getChecklistToSubcategory,
  getItemsCheckList,
  getOnlyCrews,
  getProjectCheckList,
  getUnitJobDetails,
  saveItemsCheckList,
  updateItemsCheckList,
  updateProjectCheckList,
} from "../API";
import Loader from "../pages/Loader";
import DeleteIcon from "../assets/images/cross.png";
import { toast } from "react-toastify";
import AddpicsUnitJobModal from "../components/modal/AddpicsUnitJobModal";
import StatusChangeNotesModal from "../components/modal/StatusChangeNotesModal";
import ChecklistNotesHistory from "../components/ChecklistNotesHistory";
import ChecklistComments from "../components/ChecklistComments";
import { ACTIONS } from "../utils/checklistStatus";


// import "./UnitJob.css"; // Add this file for custom styles

// The generic fallback copy for a rejected Return when the server's
// `message` is absent (production, pre-CLNOTE-B009) — TRD §3.5 "defence in
// depth" / TR1 contingency.
const NOTE_REQUIRED_FALLBACK_MESSAGE =
  "A reason is required when returning a checklist.";

const ACTION_FAIL_MESSAGE = {
  [ACTIONS.COMPLETE]: "Failed to update checklist status",
  [ACTIONS.APPROVE]: "Failed to approve project checklist",
  [ACTIONS.RETURN]: "Failed to return project checklist",
};

const UnitJob = () => {
  const { project_checklist_id } = useParams();
  const parsedProjectCheckListId = Number(project_checklist_id);
  const [projectDetails, setProjectDetails] = useState();
  const [unitJobs, setUnitJobs] = useState([]);
  const [crewListOptions, setCrewListOptions] = useState([]);
  const [selectedCrew, setSelectedCrew] = useState({});
  const [additionalItemsOptions, setAdditionalItemsOptions] = useState([]);
  const [selectedAdditionalItems, setSelectedAdditionalItems] = useState([]);
  const [showAdditionalItems, setShowAdditionalItems] = useState([]);
  const [checkListQuantity, setCheckListQuantity] = useState([]);
  const [existingCheckListItems, setExistingCheckListItems] = useState([]);
  const [updatedCheckListItems, setUpdatedCheckListItems] = useState([]);
  const [updatedProjectCheckList, setUpdatedProjectCheckList] = useState({});
  const [removeAddtionalCheckListItems, setRemoveAddtionalCheckListItems] =
    useState([]);
  const [totalCrewPoints, setTotalCrewPoints] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [checklistCategories, setChecklistCategories] = useState([]);
  const [checklistToSubcategory, setChecklistToSubcategory] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  // Detail-track status-change state (TRD §2.4, CLNOTE-F007): the single
  // channel between a trigger button and StatusChangeNotesModal. Job
  // Complete, Approve, and both Return branches all funnel through this
  // instead of calling updateProjectCheckList directly.
  const [pendingAction, setPendingAction] = useState(null); // {action, fromStatus, toStatus} | null
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState(null);
  // Bumped after a successful status change so ChecklistNotesHistory
  // refetches (CLNOTE-F008, AC-F5.8). Every transition on this page
  // navigates away on success, so this mainly matters if that ever changes;
  // it costs nothing to keep correct today.
  const [notesRefreshToken, setNotesRefreshToken] = useState(0);

  // Comments button/panel state (TRD §3.11, CLCMT-F008). `commentCount`
  // seeds the button label from the page-load count probe below and is then
  // kept in step by ChecklistComments' onCountChange after every write.
  // `commentsAvailable` is the R1 capability gate: it starts false and is
  // only set true once the count probe proves the route exists, so a
  // frontend that reaches production ahead of the backend shows no door
  // that 404s. `hasOpenedComments` defers mounting <ChecklistComments> (and
  // therefore its list fetch) until the panel is opened for the first time
  // (AC-F1.8, AC-F1.10, AC-T3).
  const [commentCount, setCommentCount] = useState(null);
  const [commentsAvailable, setCommentsAvailable] = useState(false);
  const [hasOpenedComments, setHasOpenedComments] = useState(false);

  // R1 capability-gate probe: a single lightweight count request rides page
  // load (AC-F1.10). A backend without the route 404s, and baseApi.js's
  // interceptor toasts + *resolves* an unnamed 404 with a non-response
  // value rather than rejecting (TRD §1.1 finding 2) — so `typeof
  // res?.data === "undefined"` is what distinguishes a real payload from
  // that quiet-failure shape (TRD §3.11).
  useEffect(() => {
    if (!parsedProjectCheckListId) return undefined;
    let cancelled = false;

    (async () => {
      try {
        const res = await getChecklistCommentCount(parsedProjectCheckListId);
        if (cancelled) return;
        if (typeof res?.data === "undefined") {
          setCommentsAvailable(false);
          return;
        }
        const rows = Array.isArray(res.data) ? res.data : [];
        const match = rows.find(
          (row) => Number(row.project_check_list_id) === parsedProjectCheckListId
        );
        setCommentCount(match ? match.count : 0);
        setCommentsAvailable(true);
      } catch (error) {
        if (!cancelled) setCommentsAvailable(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [parsedProjectCheckListId]);

  const checkListItemToggle = (e) => {
    const checked = e.target.checked;
    setUpdatedProjectCheckList((prev) => ({ ...prev, is_hourly: checked }));
  };

  const role = localStorage.getItem("role_name");
  const user_id = JSON.parse(localStorage.getItem("user_id"));
  const isChecklistApprover = JSON.parse(localStorage.getItem("checklist_approver") || "false");

  const isDisabled = isChecklistApprover ? false : (
    (projectDetails?.foreman_user_id === user_id &&
      role === "Foreman" &&
      projectDetails?.status > 1) ||
    (role === "General Foreman" &&
      projectDetails?.general_foreman_user_id === user_id &&
      projectDetails?.status === 4) ||
    (role === "Foreman GeneralForeman" &&
      projectDetails?.foreman_user_id === user_id &&
      projectDetails?.status > 1) ||
    (role === "Foreman GeneralForeman" &&
      (projectDetails?.general_foreman_user_id === user_id ||
        projectDetails?.foreman_user_id === user_id) &&
      projectDetails?.status === 4)
  );

  const showJobComplete = projectDetails?.status <= 1;

  const isApproveButtonsVisible =
    projectDetails?.status > 1 && projectDetails?.status <= 4;

  const navigate = useNavigate();

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "42px",
      border: "1px solid #d8dbe2",
      borderColor: state.isFocused ? "var(--primary-color)" : "#d8dbe2",
      boxShadow: "none",
      borderRadius: "10px",
      backgroundColor: isDisabled ? "#f6f7f9" : "#fff",
      cursor: isDisabled ? "not-allowed" : "pointer",
      "&:hover": {
        borderColor: state.isFocused ? "var(--primary-color)" : "#bfc5d2",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#7a8191",
      fontSize: "14px",
      fontWeight: 500,
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1f2430",
      fontSize: "14px",
      fontWeight: 600,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "var(--primary-color)" : "#7a8191",
      paddingRight: "12px",
      "&:hover": {
        color: "var(--primary-color)",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: "0",
      borderRadius: "12px",
      overflow: "hidden",
      border: "1px solid #e4e7ec",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      padding: "6px",
    }),
    option: (base, state) => ({
      ...base,
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: state.isSelected ? 700 : 500,
      backgroundColor: state.isSelected
        ? "var(--primary-color)"
        : state.isFocused
        ? "#f3f6fb"
        : "#fff",
      color: state.isSelected ? "#fff" : "#1f2430",
      cursor: "pointer",
      "&:active": {
        backgroundColor: state.isSelected ? "var(--primary-color)" : "#e9eef8",
      },
    }),
  };

  const additionalItemsSelectStyles = {
    ...customSelectStyles,
    control: (base, state) => ({
      ...base,
      backgroundColor: "var(--primary-color)",
      border: "0",
      boxShadow: "none",
      borderRadius: "0",
      minHeight: "40px",
      opacity: 1,
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      "&:hover": {
        backgroundColor: "var(--primary-color)",
      },
    }),
    container: (base) => ({
      ...base,
      backgroundColor: "var(--primary-color)",
      borderRadius: "0 0 4px 4px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 12px",
      backgroundColor: "var(--primary-color)",
      borderRadius: 0,
    }),
    input: (base) => ({
      ...base,
      color: "#fff",
      backgroundColor: "transparent",
      margin: 0,
      padding: 0,
    }),
    placeholder: (base) => ({
      ...customSelectStyles.placeholder(base),
      color: "#fff",
      fontWeight: 600,
      opacity: 1,
    }),
    singleValue: (base) => ({
      ...customSelectStyles.singleValue(base),
      color: "#fff",
      opacity: 1,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      backgroundColor: "var(--primary-color)",
      borderRadius: 0,
      opacity: 1,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#fff",
      padding: "0 12px",
      opacity: 1,
      "&:hover": {
        color: "#fff",
      },
    }),
    menu: (base) => ({
      ...customSelectStyles.menu(base),
      marginTop: "0",
    }),
  };

  useEffect(() => {
    fetchProjectDetails(project_checklist_id);
    fetchUnitJobs();
    // fetchCheckListItems();
  }, [project_checklist_id]);

  useEffect(() => {
    fetchChecklistCategories();
    fetchChecklistToSubcategories();
  }, []);

  useEffect(() => {
    if (checklistCategories.length === 0) {
      return;
    }

    const savedCategoryId = projectDetails?.checklist_category_id ?? null;
    const fallbackCategoryId = checklistCategories[0]?.id ?? null;
    const nextCategoryId = activeCategoryId ?? savedCategoryId ?? fallbackCategoryId;

    if (nextCategoryId && activeCategoryId !== nextCategoryId) {
      setActiveCategoryId(nextCategoryId);
    }

    setUpdatedProjectCheckList((prev) => ({
      ...prev,
      checklist_category_id:
        prev?.checklist_category_id ?? savedCategoryId ?? fallbackCategoryId,
    }));
  }, [checklistCategories, projectDetails, activeCategoryId]);

  const clearState = () => {
    setProjectDetails(undefined);
    setUnitJobs([]);
    setAdditionalItemsOptions([]);
    setSelectedAdditionalItems([]);
    setShowAdditionalItems([]);
    setCheckListQuantity([]);
    setExistingCheckListItems([]);
    setUpdatedCheckListItems([]);
    setUpdatedProjectCheckList({});
    setRemoveAddtionalCheckListItems([]);
    setTotalCrewPoints(0);
  };

  const fetchProjectDetails = async (project_checklist_id) => {
    const query = `id=${project_checklist_id}&expand=project%2Cforeman_user%2Cgeneral_foreman_user`;
    try {
      setIsLoading(true);
      const res = await getProjectCheckList(query);
      const crewListRes = await getOnlyCrews();

      if (res?.data?.length > 0) {
        setProjectDetails(res?.data[0]);
        if (res?.data[0]?.checklist_category_id) {
          setActiveCategoryId(res?.data[0]?.checklist_category_id);
        }
        setUpdatedProjectCheckList({
          id: res?.data[0]?.id,
          project: res?.data[0]?.project?.description,
          pole_number: res?.data[0]?.pole_number,
          kv: res?.data[0]?.kv,
          access: res?.data[0]?.access,
          work_order_number: res?.data[0]?.work_order_number,
          is_hourly: Boolean(res?.data[0]?.is_hourly),
          checklist_category_id: res?.data[0]?.checklist_category_id ?? null,
        });
        // setIsLoading(false);
      }
      if (crewListRes?.data?.length > 0) {
        const crewOptions = crewListRes.data.map((crew) => ({
          label: `${crew.virtual_id} (${crew._foreman} - ${crew._general_foreman})`,
          value: crew.id,
        }));
        const defaultSelectedCrewOption = crewOptions.find(
          (item) => item?.value === res?.data[0]?.crew_id
        );
        setSelectedCrew(defaultSelectedCrewOption || {});
        setCrewListOptions(crewOptions);
      }
    } catch (error) {
      console.error("Failed to fetch project details", error);
    }
  };

  const fetchCheckListItems = async () => {
    const query = `project_check_list_id=${project_checklist_id}`;
    let res;
    try {
      res = await getItemsCheckList(query);
    } catch (error) {
      console.error("Failed to fetch checklist items", error);
    }
    // setIsLoading(false);
    return res?.data || [];
  };

  const fetchChecklistCategories = async () => {
    try {
      const res = await getChecklistCategory();
      const sortedCategories = [...(res?.data || [])].sort((a, b) =>
        Number(a?.sort_order ?? Number.MAX_SAFE_INTEGER) -
        Number(b?.sort_order ?? Number.MAX_SAFE_INTEGER)
      );
      setChecklistCategories(sortedCategories);
      setActiveCategoryId((prev) => prev ?? sortedCategories[0]?.id ?? null);
    } catch (error) {
      console.error("Failed to fetch checklist categories", error);
      setChecklistCategories([]);
    }
  };

  const fetchChecklistToSubcategories = async () => {
    try {
      const res = await getChecklistToSubcategory();
      setChecklistToSubcategory(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch checklist to subcategory mappings", error);
      setChecklistToSubcategory([]);
    }
  };

  const fetchUnitJobs = async () => {
    try {
      const res = await getUnitJobDetails();
      const checkListItems = await fetchCheckListItems();
      const subcategoryMappingRes = await getChecklistToSubcategory();
      const additionalItemIdSet = new Set(
        (subcategoryMappingRes?.data || [])
          .filter(
            (mapping) =>
              normalizeGroupKey(mapping?.checklist_subcategory?.name) ===
              "additional_items"
          )
          .map((mapping) => mapping.checklist_id)
      );
      if (res?.data?.length > 0) {
        const unitJobsWithQuantities = res.data.map((item) => {
          const existingItem = checkListItems.find(
            (checkItem) => checkItem.check_list_id === item.id
          );
          return {
            ...item,
            quantity: existingItem ? existingItem.quantity : 0,
            crew_points: existingItem ? existingItem.crew_point : 0,
          };
        });

        const filteredCheckListItemQuantity = checkListItems.map((item) => {
          return {
            check_list_id: item.check_list_id,
            project_check_list_id: parsedProjectCheckListId,
            quantity: item.quantity,
            type: item.type,
            update_item_id: item.id,
          };
        });

        setExistingCheckListItems(filteredCheckListItemQuantity);
        setUnitJobs(unitJobsWithQuantities);

        const additional = unitJobsWithQuantities?.reduce((acc, item) => {
          if (additionalItemIdSet.has(item.id)) {
            acc.push({
              label: `${item.service_number} - ${item.description}`,
              value: item.id,
              uom: item.uom,
              quantity: item.quantity,
              check_list_item_id: item.id,
              project_check_list_id: parsedProjectCheckListId,
              crew_point_multiplier: item.crew_point_multiplier,
              service_number: item.service_number,
              crew_points: item.crew_points
            });
          }
          return acc;
        }, []);

        const additionalUnits = additional.sort((a,b)=> {
          return a.service_number - b.service_number
        })

        const filterAdditionalItems = filteredCheckListItemQuantity.reduce(
          (acc, item) => {
            const additionalItemsOptions = additionalUnits.find(
              (additionalItem) =>
                additionalItem.check_list_item_id === item.check_list_id
            );
            if (item.type === "additional_items" && additionalItemsOptions) {
              acc.push({
                label: additionalItemsOptions.label,
                value: additionalItemsOptions.value,
                uom: additionalItemsOptions.uom,
                quantity: item.quantity || 0,
                check_list_item_id: additionalItemsOptions.check_list_item_id,
                project_check_list_id: item.project_check_list_id,
                update_item_id: item.update_item_id,
                crew_point_multiplier:
                  additionalItemsOptions.crew_point_multiplier,
                  crew_points: additionalItemsOptions.crew_points
              });
            }

            return acc;
          },
          []
        );
        // Remove items in filterAdditionalItems from additionalUnits
        const filterAdditionalItemIds = new Set(
          filterAdditionalItems.map((item) => item.check_list_item_id)
        );
        const updatedAdditionalUnits = additionalUnits
          .filter(
            (item) => !filterAdditionalItemIds.has(item.check_list_item_id)
          )
          .map(({ quantity, crew_point_multiplier, ...rest }) => rest);

        const totalCrewPoints = unitJobsWithQuantities.reduce((sum, item) => {
          return sum + Number(item.crew_points || 0);
        }, 0);
        const formattedTotal = parseFloat(totalCrewPoints.toFixed(2));
        setTotalCrewPoints(formattedTotal);
        setAdditionalItemsOptions(updatedAdditionalUnits);
        setShowAdditionalItems(filterAdditionalItems);
      }
    } catch (error) {
      console.error("Failed to fetch project details", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCrewChange = (crew) => {
    setUpdatedProjectCheckList((prev) => ({
      ...prev,
      crew_id: crew.value,
    }));
    setSelectedCrew(crew);
  };

  const handleAdditionalItems = (data) => {
    const filterAdditionalItemsList = additionalItemsOptions.filter(
      (item) => item.value !== data.value
    );
    setAdditionalItemsOptions(filterAdditionalItemsList);
    setSelectedAdditionalItems((prev) => [
      ...prev,
      { type: "additional_items", ...data },
    ]);
    setShowAdditionalItems((prev) => [
      ...prev,
      { type: "additional_items", ...data },
    ]);
  };

  const upsertItems = (items, matcher, updater, creator) => {
    const index = items.findIndex(matcher);
    if (index > -1) {
      const updatedItems = [...items];
      updatedItems[index] = updater(updatedItems[index]);
      return updatedItems;
    }
    return [...items, creator()];
  };

  const handleRemoveAdditionalItem = (item) => {
    setSelectedAdditionalItems((prev) =>
      prev.filter((selectedItem) => selectedItem.value !== item.value)
    );
    setShowAdditionalItems((prev) =>
      prev.filter((selectedItem) => selectedItem.value !== item.value)
    );
    setAdditionalItemsOptions((prev) => [...prev, item]);
    if (item?.update_item_id) {
      setRemoveAddtionalCheckListItems((prev) => {
        // Check if the item already exists in the array
        const exists = prev.some(
          (existingItem) =>
            existingItem.check_list_id === item.check_list_item_id &&
            existingItem.update_item_id === item.update_item_id
        );

        // If it exists, return the previous state without modifying
        if (exists) {
          return prev;
        }

        // Otherwise, return the updated array with the new item
        return [
          ...prev,
          {
            check_list_id: item.check_list_item_id,
            project_check_list_id: parsedProjectCheckListId,
            type: "additional_items",
            update_item_id: item.update_item_id,
          },
        ];
      });
    }
  };

  const handleCheckListQuantityChange = (e, value, type) => {
    const newQuantity = Number(e.target.value);
    const existingItem = existingCheckListItems.find(
      (item) =>
        item.check_list_id === value.id &&
        item.type === type &&
        item.project_check_list_id === parsedProjectCheckListId
    );

    if (existingItem) {
      if (existingItem.quantity !== newQuantity) {
        setUpdatedCheckListItems((prev) => {
          return upsertItems(
            prev,
            (item) =>
              item.check_list_id === value.id &&
              item.type === type &&
              item.project_check_list_id === parsedProjectCheckListId,
            (item) => ({
              ...item,
              quantity: newQuantity,
            }),
            () => ({
              ...existingItem,
              quantity: newQuantity,
            })
          );
        });
      }
    } else {
      setCheckListQuantity((prev) => {
        return upsertItems(
          prev,
          (item) =>
            item.check_list_id === value.id &&
            item.type === type &&
            item.project_check_list_id === parsedProjectCheckListId,
          (item) => ({
            ...item,
            quantity: newQuantity,
          }),
          () => ({
            project_check_list_id: parsedProjectCheckListId,
            check_list_id: Number(value.id),
            quantity: newQuantity,
            type,
          })
        );
      });
    }
  };

  const handleAdditionalItemsQuantityChange = (e, item) => {
    const newQuantity = Number(e.target.value);
    const existingItem = existingCheckListItems.find(
      (existing) =>
        existing.check_list_id === item.check_list_item_id &&
        existing.type === "additional_items" &&
        existing.project_check_list_id === parsedProjectCheckListId
    );

    if (existingItem) {
      if (existingItem.quantity !== newQuantity) {
        setUpdatedCheckListItems((prev) => {
          return upsertItems(
            prev,
            (entry) =>
              entry.check_list_id === item.check_list_item_id &&
              entry.type === "additional_items" &&
              entry.project_check_list_id === parsedProjectCheckListId,
            (entry) => ({
              ...entry,
              quantity: newQuantity,
            }),
            () => ({
              ...existingItem,
              quantity: newQuantity,
            })
          );
        });
      }
    } else {
      setSelectedAdditionalItems((prev) => {
        return upsertItems(
          prev,
          (selectedItem) => selectedItem.value === item.value,
          (selectedItem) => ({
            ...selectedItem,
            quantity: newQuantity,
          }),
          () => ({
            ...item,
            quantity: newQuantity,
          })
        );
      });
      setShowAdditionalItems((prev) => {
        return upsertItems(
          prev,
          (selectedItem) => selectedItem.value === item.value,
          (selectedItem) => ({
            ...selectedItem,
            quantity: newQuantity,
          }),
          () => ({
            ...item,
            quantity: newQuantity,
          })
        );
      });
    }
  };

  const handleProjectCheckListDetails = (e) => {
    const { name, value } = e.target;

    const parsedValue = name === "kv" ? Number(value) : value;

    setUpdatedProjectCheckList((prev) => ({
      ...prev,
      [name]: name === "kv" && prev[name] === parsedValue ? null : parsedValue,
    }));
  };

  const handleChecklistCategoryClick = (categoryId) => {
    setActiveCategoryId(categoryId);
    setUpdatedProjectCheckList((prev) => ({
      ...prev,
      checklist_category_id: categoryId,
    }));
  };


  const handleSave = async () => {
    const effectiveChecklistCategoryId =
      activeCategoryId ??
      updatedProjectCheckList?.checklist_category_id ??
      projectDetails?.checklist_category_id ??
      checklistCategories[0]?.id ??
      null;

    const shouldUpdateProjectDetails =
      projectDetails?.pole_number !== updatedProjectCheckList?.pole_number ||
      projectDetails?.kv !== updatedProjectCheckList?.kv ||
      projectDetails?.access !== updatedProjectCheckList?.access ||
      projectDetails?.work_order_number !==
      updatedProjectCheckList?.work_order_number ||
      projectDetails?.crew_id !== updatedProjectCheckList?.crew_id ||
      Boolean(projectDetails?.is_hourly) !== Boolean(updatedProjectCheckList?.is_hourly) ||
      projectDetails?.checklist_category_id !==
      effectiveChecklistCategoryId;

    setIsLoading(true);
    let additionalSelectedItems = [];
    if (selectedAdditionalItems.length > 0) {
      additionalSelectedItems = selectedAdditionalItems.map((item) => {
        return {
          project_check_list_id: parsedProjectCheckListId,
          check_list_id: Number(item.value),
          quantity: item.quantity || 0,
          type: item.type,
        };
      });
    }
    try {
      // Update project checklist details if changed
      if (shouldUpdateProjectDetails) {
        await updateProjectCheckList(project_checklist_id, {
          pole_number: updatedProjectCheckList?.pole_number,
          kv: updatedProjectCheckList?.kv,
          access: updatedProjectCheckList?.access,
          work_order_number: updatedProjectCheckList?.work_order_number,
          crew_id: updatedProjectCheckList?.crew_id,
          is_hourly: Boolean(updatedProjectCheckList?.is_hourly),
          checklist_category_id: effectiveChecklistCategoryId,
        });
      }

      if (removeAddtionalCheckListItems.length > 0) {
        await Promise.all(
          removeAddtionalCheckListItems.map((item) =>
            deleteItemsCheckList(item.update_item_id)
          )
        );
      }

      // Update existing checklist items if any
      if (updatedCheckListItems.length > 0) {
        await Promise.all(
          updatedCheckListItems.map((item) =>
            updateItemsCheckList(item.update_item_id, {
              check_list_id: item.check_list_id,
              quantity: item.quantity,
              project_check_list_id: parsedProjectCheckListId,
              type: item.type,
            })
          )
        );
      }

      // Save new checklist items if any
      if (checkListQuantity.length > 0 && additionalSelectedItems.length > 0) {
        const data = await saveItemsCheckList([
          ...checkListQuantity,
          ...additionalSelectedItems,
        ]);
        if (data?.status === 200) {
          toast.success("Items saved successfully");
          // navigate(-1);
          // return;
        }
      } else if (
        checkListQuantity.length > 0 &&
        additionalSelectedItems.length === 0
      ) {
        const data = await saveItemsCheckList([...checkListQuantity]);
        if (data?.status === 200) {
          toast.success("Items saved successfully");
          // navigate(-1);
          // return;
        }
      } else if (
        additionalSelectedItems.length > 0 &&
        checkListQuantity.length === 0
      ) {
        const data = await saveItemsCheckList([...additionalSelectedItems]);
        if (data?.status === 200) {
          toast.success("Items saved successfully");
          // navigate(-1);
          // return;
        }
      }

      // If only project details or updates were made
      if (
        shouldUpdateProjectDetails ||
        (updatedCheckListItems.length > 0 && checkListQuantity.length === 0)
      ) {
        toast.success("Checklist updated successfully");
        // navigate(-1);
      }
    } catch (error) {
      console.error("Checklist save failed:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
      fetchUnitJobs();
      fetchProjectDetails(project_checklist_id);
      clearState();
    }
  };

  const showQuantity = (item) => {
    const existingItem = existingCheckListItems.find((checkItem) => {
      return checkItem.check_list_id === item.id && checkItem.type === "fixed";
    });
    return Number(existingItem?.quantity) || 0;
  };

  const showAdditionalItemsQuantity = (item) => {
    const existingItem = existingCheckListItems.find((checkItem) => {
      return (
        checkItem.check_list_id === item.value &&
        checkItem.type === "additional_items"
      );
    });
    return Number(existingItem?.quantity) || 0;
  };


  const normalizeGroupKey = (value = "") =>
    value.toString().trim().toLowerCase().replace(/\s+/g, "_");

  const activeCategoryMappings = useMemo(() => {
    return checklistToSubcategory.filter(
      (item) =>
        item?.checklist_subcategory?.checklist_category_id === activeCategoryId
    );
  }, [checklistToSubcategory, activeCategoryId]);

  const activeChecklistSubcategoryMap = useMemo(() => {
    return activeCategoryMappings.reduce((acc, item) => {
      acc[item.checklist_id] = {
        subcategoryId: item?.checklist_subcategory?.id,
        subcategoryName: item?.checklist_subcategory?.name || "",
        normalizedName: normalizeGroupKey(item?.checklist_subcategory?.name),
      };
      return acc;
    }, {});
  }, [activeCategoryMappings]);

  const groupedItems = useMemo(() => {
    const scopedUnitJobs =
      activeCategoryMappings.length > 0
        ? unitJobs.filter((item) => activeChecklistSubcategoryMap[item.id])
        : unitJobs;

    const grouped = _.groupBy(scopedUnitJobs, (item) => {
      return activeChecklistSubcategoryMap[item.id]?.normalizedName ||
        normalizeGroupKey(item.type);
    });

    return _.mapValues(grouped, (group) =>
      _.orderBy(group, ["service_number"], ["asc"])
    );
  }, [unitJobs, activeCategoryMappings, activeChecklistSubcategoryMap]);

  const visibleSubcategories = useMemo(() => {
    if (!activeCategoryId) {
      return [];
    }

    const subcategories = activeCategoryMappings.reduce((acc, item) => {
      const subcategory = item?.checklist_subcategory;
      if (!subcategory) {
        return acc;
      }

      const normalizedName = normalizeGroupKey(subcategory.name);
      if (!acc.some((entry) => entry.normalizedName === normalizedName)) {
        acc.push({
          id: subcategory.id,
          name: subcategory.name,
          normalizedName,
          sortOrder: Number(subcategory.sort_order ?? Number.MAX_SAFE_INTEGER),
        });
      }
      return acc;
    }, []);

    return _.orderBy(subcategories, ["sortOrder"], ["asc"]).filter(
      (subcategory) =>
        groupedItems[subcategory.normalizedName]?.length > 0 ||
        subcategory.normalizedName === "additional_items"
    );
  }, [activeCategoryId, activeCategoryMappings, groupedItems]);
  const renderTable = (title, groupKey) => (
    <div className="unit-section">
      <h3>{title}</h3>
      {groupKey === "additional_items" && (
        <div className="col-xl-12" style={{ marginTop: 0 }}>
          <Select
            isDisabled={isDisabled}
            styles={additionalItemsSelectStyles}
            name="additionalItems"
            placeholder="Select Item to add"
            value={null}
            onChange={(data) => handleAdditionalItems(data)}
            aria-label="Default select example"
            options={additionalItemsOptions}
          />
        </div>
      )}
      <div
        className={`${
          groupKey === "additional_items"
            ? "additional-items-table"
            : "unit-section-table-scroll"
        }`}
      >
        <table className="table-striped table ">
          <thead>
            <tr>
              <th style={{width: "55%"}}>Description</th>
              <th>UOM</th>
              <th style={{textAlign: "center"}}>QTY</th>
              <th style={{textAlign: "right"}}>Points</th>
               {groupKey === "additional_items" && <th>X</th>}
            </tr>
          </thead>
          <tbody>
            {(groupedItems[groupKey] || []).map((item) => {
              return (
               groupKey !== "additional_items" && (<tr key={item.id}>
                  <td>{item.description}</td>
                  <td>{item.uom || "-"}</td>
                  <td style={{textAlign: "center"}}>
                    <input
                      disabled={isDisabled}
                      placeholder={showQuantity(item)}
                      onChange={(e) =>
                        handleCheckListQuantityChange(e, item, "fixed")
                      }
                      style={{ width: "50px" }}
                      type="number"
                    />
                  </td>
                  <td>
                    {item.crew_points}
                  </td>
                </tr>)
              );
            })}
            {groupKey === "additional_items" &&
              (showAdditionalItems || []).map((item) => (
                <tr key={item.id}>
                  <td>{item.label}</td>
                  <td>{item.uom || "-"}</td>
                  <td>
                    <input
                      disabled={isDisabled}
                      placeholder={showAdditionalItemsQuantity(item) || ""}
                      onChange={(e) =>
                        handleAdditionalItemsQuantityChange(
                          e,
                          item,
                          "additional_items"
                        )
                      }
                      style={{ width: "50px" }}
                      type="number"
                    />
                  </td>
                  <td>
                  {item.crew_points}
                  </td>
                  <td>
                    {!isDisabled && (
                      <img
                        style={{ width: "20px", cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveAdditionalItem(item);
                        }}
                        src={DeleteIcon}
                        alt=""
                      />
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  // Job Complete, Approve, and Return no longer call updateProjectCheckList
  // directly (CLNOTE-F007). Each one only stages a `pendingAction` and opens
  // StatusChangeNotesModal; the actual PUT happens in
  // handlePendingActionConfirm once the user confirms (with a note where the
  // action requires one). Visibility gating for these buttons is untouched
  // (NG18) — only what a click *does* has changed.
  const handleClickApprove = () => {
    setServerError(null);
    setPendingAction({
      action: ACTIONS.APPROVE,
      fromStatus: projectDetails?.status,
      toStatus: 4,
    });
  };

  const handleClickReturn = () => {
    // Both Return branches funnel through the same mandatory-note action:
    // {2,3} -> 1 for a normal return, and 4 -> 2 for a return-from-Approved.
    const toStatus = projectDetails?.status === 4 ? 2 : 1;
    setServerError(null);
    setPendingAction({
      action: ACTIONS.RETURN,
      fromStatus: projectDetails?.status,
      toStatus,
    });
  };

  const handleReviewedToggle = async() => {
    const payload = {
      is_reviewed: !projectDetails.is_reviewed,
    };
    await updateProjectCheckList(project_checklist_id, payload).then((res) => {
      if (res?.status === 200) {
        toast.success("CheckList Status Updated");
        // navigate(-1)
        setProjectDetails(prev => ({...prev, is_reviewed: !prev.is_reviewed}))
      }
    });
  };

  const onJobDoneClick = () => {
    setServerError(null);
    setPendingAction({
      action: ACTIONS.COMPLETE,
      fromStatus: projectDetails?.status,
      toStatus: 2,
    });
  };

  const handlePendingActionCancel = () => {
    if (isSubmitting) return;
    setPendingAction(null);
    setServerError(null);
  };

  // Single confirm handler for all three transitions (Job Complete, Approve,
  // Return). Sends the existing PUT payload plus `status_note` (CLNOTE-F007).
  // A rejected 400 StatusNoteRequiredError is caught here — propagated by the
  // baseApi.js interceptor change (CLNOTE-F003) — and surfaced inline via the
  // modal's `serverError` prop instead of a toast, with the typed note
  // preserved because the modal stays open (TRD §2.3.2, §3.6).
  const handlePendingActionConfirm = async (note) => {
    if (!pendingAction) return;
    setIsSubmitting(true);
    setServerError(null);
    try {
      const updatedRes = await updateProjectCheckList(
        updatedProjectCheckList?.id,
        { status: pendingAction.toStatus, status_note: note ?? null }
      );
      if (updatedRes?.status === 200) {
        if (pendingAction.action === ACTIONS.COMPLETE) {
          toast.success("CheckList Status Updated");
        } else if (pendingAction.action === ACTIONS.APPROVE) {
          toast.success("Project checklist approved successfully");
        } else if (pendingAction.action === ACTIONS.RETURN) {
          toast.success("Project checklist returned successfully");
        }
        setIsSubmitting(false);
        setPendingAction(null);
        setNotesRefreshToken((prev) => prev + 1);
        navigate(-1);
        return;
      }
      // Defensive: axios resolves the request promise only on 2xx today, so
      // this branch mirrors the pre-existing (effectively unreachable)
      // fallback rather than changing behaviour.
      toast.error(ACTION_FAIL_MESSAGE[pendingAction.action]);
      setIsSubmitting(false);
    } catch (error) {
      if (error?.response?.data?.name === "StatusNoteRequiredError") {
        setServerError(
          error?.response?.data?.message || NOTE_REQUIRED_FALLBACK_MESSAGE
        );
        setIsSubmitting(false);
        return;
      }
      console.error(
        `Error confirming ${pendingAction.action} for project checklist:`,
        error
      );
      toast.error(ACTION_FAIL_MESSAGE[pendingAction.action]);
      setIsSubmitting(false);
    }
  };
  return Object.keys(groupedItems).length > 0 ? (
    <>
      <div className="unit-job-container">
        <div className="unit-job-top-container">
          <Row className="d-flex justify-content-between align-items-center heading-container ">
            {/* Back Button */}
            <Col className="d-flex align-items-center " xxl={4} xl={3}>
              <button
                className="primary-btn back-btn"
                onClick={() => navigate(-1)}

              >
              <svg viewBox="0 0 1024 1024" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M640 192L320 512l320 320" />
              </svg>
              <span>Back</span>
              </button>
            </Col>
            <Col xxl={4} xl={6}>
            <div className="checklist-title"><h1>{updatedProjectCheckList?.project}</h1></div>
            </Col>

            {/* Right Buttons */}
            <Col className="d-flex justify-content-end gap-2 ms-auto text-end" xxl={4} xl={3}>
            {(isChecklistApprover || (user_id !== projectDetails?.foreman_user_id && role !== "Foreman")) &&
              isApproveButtonsVisible && (

                  <div className="d-flex gap-3">
                    {/* Return button visibility logic for Foreman GeneralForeman role */}
                    {((role === "Foreman GeneralForeman" &&
                      projectDetails?.status < 4 &&
                      projectDetails?.general_foreman_user_id === user_id) ||
                      role !== "Foreman GeneralForeman" || isChecklistApprover) && (
                      <button
                        disabled={!isChecklistApprover && user_id === projectDetails?.foreman_user_id}
                        onClick={() => handleClickReturn()}
                        className="primary-btn-less-width return-btn"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M88 256L232 256C241.7 256 250.5 250.2 254.2 241.2C257.9 232.2 255.9 221.9 249 215L202.3 168.3C277.6 109.7 386.6 115 455.8 184.2C530.8 259.2 530.8 380.7 455.8 455.7C380.8 530.7 259.3 530.7 184.3 455.7C174.1 445.5 165.3 434.4 157.9 422.7C148.4 407.8 128.6 403.4 113.7 412.9C98.8 422.4 94.4 442.2 103.9 457.1C113.7 472.7 125.4 487.5 139 501C239 601 401 601 501 501C601 401 601 239 501 139C406.8 44.7 257.3 39.3 156.7 122.8L105 71C98.1 64.2 87.8 62.1 78.8 65.8C69.8 69.5 64 78.3 64 88L64 232C64 245.3 74.7 256 88 256z"/></svg>
                        <span>Return</span>
                      </button>
                    )}
                    {projectDetails.status < 4 &&
                      (isChecklistApprover || (role !== "General Foreman" &&
                      role !== "Foreman GeneralForeman")) && (
                        <button
                          disabled={!isChecklistApprover && user_id === projectDetails?.foreman_user_id}
                          onClick={() => handleClickApprove()}
                          className="primary-btn-less-width approve-btn"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320C528 205.1 434.9 112 320 112zM390.7 233.9C398.5 223.2 413.5 220.8 424.2 228.6C434.9 236.4 437.3 251.4 429.5 262.1L307.4 430.1C303.3 435.8 296.9 439.4 289.9 439.9C282.9 440.4 276 437.9 271.1 433L215.2 377.1C205.8 367.7 205.8 352.5 215.2 343.2C224.6 333.9 239.8 333.8 249.1 343.2L285.1 379.2L390.7 234z"/></svg>
                          <span>Approve</span>
                        </button>
                      )}

                    {/* Reviewed button for General Foreman role */}
                    {(role === "General Foreman" ||
                      role === "Foreman GeneralForeman" || isChecklistApprover) &&
                      projectDetails.status < 4 && (
                        <button
                          onClick={() => handleReviewedToggle()}
                          className={`primary-btn-less-width ${
                            projectDetails.is_reviewed
                              ? "primary-btn"
                              : "secondary-btn"
                          }`}
                          style={{
                            backgroundColor: projectDetails.is_reviewed
                              ? "#007bff"
                              : "#6c757d",
                            border: "none",
                            color: "white",
                          }}
                        >
                          Reviewed
                        </button>
                      )}
                  </div>

              )}
              </Col>
          </Row>
          <Row className="g-3 unit-job-option-container"> {/* 'g-3' adds a nice gutter/gap between them */}
            <Col xxl={3} xl={4} lg={12} md={12} xs={12} className="sub-container">
              <div className="px-4">
                <Row>
                  <Col xs={6}>
                    <div className="checklist-input">
                      <label>Work Order #.</label>
                      <input disabled={isDisabled} name="work_order_number" value={updatedProjectCheckList?.work_order_number} onChange={(e) => handleProjectCheckListDetails(e)} type="text" />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="checklist-input">
                      <label>Pole #</label>
                      <input disabled={isDisabled} name="pole_number" value={updatedProjectCheckList?.pole_number} onChange={(e) => handleProjectCheckListDetails(e)} type="text" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xxl={5} xl={7} lg={12} md={12} xs={12} className="sub-container">
              <div className="px-4">
                <Row>
                  <Col md={4} sm={6} xs={12}>
                    <div className={`checklist-input bordered ${isDisabled ? "disabled" : ""}`}>
                      <label htmlFor="12kv">KV</label>
                      {isDisabled ? (
                        // Show readonly value when disabled
                        <div className="kv-value">
                          {updatedProjectCheckList?.kv ? `${updatedProjectCheckList.kv}KV` : "N/A"}
                        </div>
                      ) : (
                        <>
                        <div className="toggle-group">
                          <input type="radio" name="kv" id="12kv" value={12} checked={updatedProjectCheckList?.kv === 12}
                            onClick={handleProjectCheckListDetails} />
                            <label htmlFor="12kv" >12KV</label>
                          <input type="radio" name="kv" id="35kv" value={35}   checked={updatedProjectCheckList?.kv === 35}
                            onClick={handleProjectCheckListDetails} />
                            <label htmlFor="35kv" >35KV</label>
                          <div className="toggle-slider"></div>
                        </div>

                        </>
                      )}
                    </div>
                  </Col>
                  <Col md={5} sm={6} xs={12}>
                    <div className={`checklist-input bordered ${isDisabled ? "disabled" : ""}`}>
                      <label>Access</label>
                      {isDisabled ? (
                        // Show readonly value when disabled
                        <div className="access-value">
                          {updatedProjectCheckList?.access || "N/A"}
                        </div>
                      ) : (
                        // Show radios when enabled
                        <>


                           <div className="toggle-group-access">

                          <input type="radio" name="access" id="street" value="Street" checked={updatedProjectCheckList?.access === "Street"}
                            onClick={handleProjectCheckListDetails} />
                            <label htmlFor="street" >Street</label>
                          <input type="radio" name="access" id="easement" value="Easement"   checked={updatedProjectCheckList?.access === "Easement"}
                            onClick={handleProjectCheckListDetails} />
                            <label htmlFor="easement" >Easement</label>
                          <div className="toggle-slider-access"></div>
                        </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col md={3} sm={12} xs={12}>
                    <div className={`checklist-input bordered total-points-field ${isDisabled ? "disabled" : ""}`}>
                      <label>Total Points</label>
                      <div className="total-points">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" aria-hidden="true"><path fill="currentColor" d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"/></svg>
                        {totalCrewPoints}
                      </div>

                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xxl={4} xl={8} lg={12} md={12} xs={12} className="sub-container">
              <div className="px-4 ">
                <Row>
                  <Col md={3} sm={4} xs={12}>
                    <div className={`checklist-input bordered hourly-field ${isDisabled ? "disabled" : ""}`}>
                      <label>Hourly</label>
                      <span className="toggle-container">
                         <input disabled={isDisabled} name="is_hourly" type="checkbox" checked={!!updatedProjectCheckList?.is_hourly} onChange={checkListItemToggle} id="switch" />
                        <label htmlFor="switch">Toggle</label>
                      </span>
                    </div>
                  </Col>
                  <Col md={9} sm={8} xs={12}>
                    <div className={`checklist-input bordered crew-field ${isDisabled ? "disabled" : ""}`}>
                      <label>Crew</label>
                      {isDisabled ? (
                        <div className="access-value">
                          {selectedCrew?.label || "N/A"}
                        </div>
                      ) : (
                        <Select
                          isDisabled={isDisabled}
                          styles={customSelectStyles}
                          name="additionalItems"
                          placeholder="Select"
                          value={{
                            label: selectedCrew?.label || "Select Crew",
                            value: selectedCrew?.value,
                          }}
                          onChange={(data) => handleCrewChange(data)}
                          aria-label="Default select example"
                          options={crewListOptions}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-between align-items-center footer-container">
            <Col xs={6}>
              <div className="footer-container-menu" role="group" aria-label="Checklist categories">
                {(checklistCategories.length > 0
                  ? checklistCategories
                  : [
                      { id: 1, name: "Category Poles" },
                      { id: 2, name: "Unit Rate" },
                    ]
                ).map((category, index) => {
                  const isActive =
                    category.id === activeCategoryId ||
                    (!activeCategoryId && index === 0);
                  return (
                    <button
                      key={category.id}
                      type="button"
                      aria-pressed={isActive}
                      className={`footer-container-menu-item${isActive ? " checked" : ""}`}
                      onClick={() => handleChecklistCategoryClick(category.id)}
                    >
                      {category.name}
                    </button>
                  );
                })}
              </div>
            </Col>
            <Col xs={6} className="d-flex justify-content-end">
              <div className="footer-container-actions">
              <button
                type="button"
                className="status-history-btn"
                data-bs-toggle="offcanvas"
                data-bs-target="#statusHistoryPanel"
                aria-controls="statusHistoryPanel"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M320 112C205.1 112 112 205.1 112 320C112 434.9 205.1 528 320 528C434.9 528 528 434.9 528 320C528 205.1 434.9 112 320 112zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM296 184C296 170.7 306.7 160 320 160C333.3 160 344 170.7 344 184L344 310.1L413 379.1C422.4 388.5 422.4 403.7 413 413C403.6 422.3 388.4 422.4 379.1 413L303 336.9C298.5 332.4 296 326.3 296 319.9L296 184z"/></svg>
                <span>Status History</span>
              </button>
              {commentsAvailable && (
                <button
                  type="button"
                  className="checklist-comments-btn"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#commentsPanel"
                  aria-controls="commentsPanel"
                  onClick={() => setHasOpenedComments(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 40"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      fill="currentColor"
                      d="M8 4 H32 A4 4 0 0 1 36 8 V24 A4 4 0 0 1 32 28 H16 L10 34 L8 28 A4 4 0 0 1 4 24 V8 A4 4 0 0 1 8 4 Z"
                    />
                  </svg>
                  <span>
                    {commentCount > 0 ? `Comments (${commentCount})` : "Comments"}
                  </span>
                </button>
              )}
              </div>
            </Col>
          </Row>

        </div>

        <Row className="tables-section checkListItemContainer" style={{ display: !!updatedProjectCheckList?.is_hourly ? "none" : "flex" }}>
          {visibleSubcategories.map((subcategory) => (
            <Col xxl="4" md="6" key={subcategory.id}>
              {renderTable(
                subcategory.name.toUpperCase(),
                subcategory.normalizedName
              )}
            </Col>
          ))}
        </Row>
        {isLoading && <Loader />}

        <div className="footer-buttons">
          {!isDisabled && (
            <button onClick={() => handleSave()} className="btn save save-btn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M160 144C151.2 144 144 151.2 144 160L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 237.3C496 233.1 494.3 229 491.3 226L416 150.6L416 240C416 257.7 401.7 272 384 272L224 272C206.3 272 192 257.7 192 240L192 144L160 144zM240 144L240 224L368 224L368 144L240 144zM96 160C96 124.7 124.7 96 160 96L402.7 96C419.7 96 436 102.7 448 114.7L525.3 192C537.3 204 544 220.3 544 237.3L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM256 384C256 348.7 284.7 320 320 320C355.3 320 384 348.7 384 384C384 419.3 355.3 448 320 448C284.7 448 256 419.3 256 384z"/></svg>
              <span>Save</span>
            </button>
          )}
         {isDisabled ? (
            <button
              type="button"
              className="btn add-pics view-pic-btn"
              data-bs-toggle="modal"
              data-bs-target="#addPicsUnitJob"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M288 80C222.8 80 169.2 109.6 128.1 147.7 89.6 183.5 63 226 49.4 256 63 286 89.6 328.5 128.1 364.3 169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256 513 226 486.4 183.5 447.9 147.7 406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1-47.1 43.7-111.8 80.6-192.6 80.6S142.5 443.2 95.4 399.4c-46.8-43.5-78.1-95.4-93-131.1-3.3-7.9-3.3-16.7 0-24.6 14.9-35.7 46.2-87.7 93-131.1zM288 336c44.2 0 80-35.8 80-80 0-29.6-16.1-55.5-40-69.3-1.4 59.7-49.6 107.9-109.3 109.3 13.8 23.9 39.7 40 69.3 40zm-79.6-88.4c2.5 .3 5 .4 7.6 .4 35.3 0 64-28.7 64-64 0-2.6-.2-5.1-.4-7.6-37.4 3.9-67.2 33.7-71.1 71.1zm45.6-115c10.8-3 22.2-4.5 33.9-4.5 8.8 0 17.5 .9 25.8 2.6 .3 .1 .5 .1 .8 .2 57.9 12.2 101.4 63.7 101.4 125.2 0 70.7-57.3 128-128 128-61.6 0-113-43.5-125.2-101.4-1.8-8.6-2.8-17.5-2.8-26.6 0-11 1.4-21.8 4-32 .2-.7 .3-1.3 .5-1.9 11.9-43.4 46.1-77.6 89.5-89.5z"/></svg>
              <span>View Uploaded Pics</span>
            </button>
          ) : (
            <button
              type="button"
              className="btn add-pics add-pic-btn"
              data-bs-toggle="modal"
              data-bs-target="#addPicsUnitJob"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M352 173.3L352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384L288 173.3L246.6 214.7C234.1 227.2 213.8 227.2 201.3 214.7C188.8 202.2 188.8 181.9 201.3 169.4L297.3 73.4C309.8 60.9 330.1 60.9 342.6 73.4L438.6 169.4C451.1 181.9 451.1 202.2 438.6 214.7C426.1 227.2 405.8 227.2 393.3 214.7L352 173.3zM320 464C364.2 464 400 428.2 400 384L480 384C515.3 384 544 412.7 544 448L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 448C96 412.7 124.7 384 160 384L240 384C240 428.2 275.8 464 320 464zM464 488C477.3 488 488 477.3 488 464C488 450.7 477.3 440 464 440C450.7 440 440 450.7 440 464C440 477.3 450.7 488 464 488z"/></svg>
               <span>Add Pics</span>
            </button>
          )}
          {showJobComplete && (
            <button
              className="btn complete complete-btn"
              onClick={() => onJobDoneClick()}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentColor" d="M197.8 100.3C208.7 107.9 211.3 122.9 203.7 133.7L147.7 213.7C143.6 219.5 137.2 223.2 130.1 223.8C123 224.4 116 222 111 217L71 177C61.7 167.6 61.7 152.4 71 143C80.3 133.6 95.6 133.7 105 143L124.8 162.8L164.4 106.2C172 95.3 187 92.7 197.8 100.3zM197.8 260.3C208.7 267.9 211.3 282.9 203.7 293.7L147.7 373.7C143.6 379.5 137.2 383.2 130.1 383.8C123 384.4 116 382 111 377L71 337C61.6 327.6 61.6 312.4 71 303.1C80.4 293.8 95.6 293.7 104.9 303.1L124.7 322.9L164.3 266.3C171.9 255.4 186.9 252.8 197.7 260.4zM288 160C288 142.3 302.3 128 320 128L544 128C561.7 128 576 142.3 576 160C576 177.7 561.7 192 544 192L320 192C302.3 192 288 177.7 288 160zM288 320C288 302.3 302.3 288 320 288L544 288C561.7 288 576 302.3 576 320C576 337.7 561.7 352 544 352L320 352C302.3 352 288 337.7 288 320zM224 480C224 462.3 238.3 448 256 448L544 448C561.7 448 576 462.3 576 480C576 497.7 561.7 512 544 512L256 512C238.3 512 224 497.7 224 480zM128 440C150.1 440 168 457.9 168 480C168 502.1 150.1 520 128 520C105.9 520 88 502.1 88 480C88 457.9 105.9 440 128 440z"/></svg>
              <span>Job Complete</span>
            </button>
          )}
        </div>
      </div>
      {/* Collapsible right-side panel for the status-change audit trail;
          toggled from the footer-buttons bar via Bootstrap's offcanvas
          data API, matching RightDrawerModal / RightEquipmentDrawer. */}
      <div
        className="offcanvas offcanvas-end checklist-notes-offcanvas"
        tabIndex="-1"
        id="statusHistoryPanel"
        aria-labelledby="statusHistoryPanelLabel"
      >
        <div className="offcanvas-header">
          <h3 id="statusHistoryPanelLabel">Status History</h3>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ChecklistNotesHistory
            projectCheckListId={parsedProjectCheckListId}
            refreshToken={notesRefreshToken}
            hideHeading
          />
        </div>
      </div>
      {/* Sibling comments panel (TRD §3.11, CLCMT-F008) — same offcanvas
          data-API pattern as #statusHistoryPanel above, so opening one
          natively closes the other (AC-F1.9) with zero coordination code.
          The list is mounted only after hasOpenedComments latches on the
          button's first click (AC-F1.8, AC-F1.10). */}
      <div
        className="offcanvas offcanvas-end checklist-comments-offcanvas"
        tabIndex="-1"
        id="commentsPanel"
        aria-labelledby="commentsPanelLabel"
      >
        <div className="offcanvas-header">
          <h3 id="commentsPanelLabel">Comments</h3>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          {hasOpenedComments && (
            <ChecklistComments
              projectCheckListId={parsedProjectCheckListId}
              onCountChange={setCommentCount}
            />
          )}
        </div>
      </div>
      <AddpicsUnitJobModal
        isDisabled={isDisabled}
        projectCheckListId={project_checklist_id}
      />
      <StatusChangeNotesModal
        action={pendingAction?.action}
        fromStatus={pendingAction?.fromStatus}
        toStatus={pendingAction?.toStatus}
        isOpen={Boolean(pendingAction)}
        onConfirm={handlePendingActionConfirm}
        onCancel={handlePendingActionCancel}
        serverError={serverError}
        busy={isSubmitting}
      />
    </>
  ) : (
    <>
      {/* <div className="unit-job-container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <button
              className="primary-btn back-btn"
              onClick={() => navigate(-1)}
              style={{ padding: "8px 8px" }}
            >
              <img
                src={ArrowLeft}
                alt="Back"
                style={{ verticalAlign: "middle" }}
              />
            </button>
          </div>
        </div>
      </div> */}
      {isLoading && <Loader />}
    </>
  );
};

export default UnitJob;
